import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-content-between" }
const _hoisted_2 = { class: "flex flex-column" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-lg" }
const _hoisted_6 = { class: "mb-2 text-500 text-sm" }
const _hoisted_7 = {
  key: 0,
  class: "text-4xl"
}
const _hoisted_8 = {
  key: 1,
  class: "text-4xl text-pink-600"
}
const _hoisted_9 = { class: "flex flex-column align-items-end" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check-circle" }, null, -1)
const _hoisted_11 = ["textContent"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle" }, null, -1)
const _hoisted_13 = ["textContent"]

import Menu from "primevue/menu";
import Card from "primevue/card";
import { computed, ref } from "vue";
import {
  TargetDodResponse,
  TargetResponse,
  TriggerDirection,
} from "@evolutivelabs/quokka-common";
import router from "@/router";
import { useTargetStore } from "@/store/target.store";
import { calculateTimeAgo } from "./utils";


export default /*#__PURE__*/_defineComponent({
  props: {
    target: null,
    targetDods: null
  },
  emits: ["edit-target", "share-target", "cancel-subscribe"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "edit-target"): void;
  (e: "share-target"): void;
  (e: "cancel-subscribe"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  target: TargetResponse;
  targetDods: TargetDodResponse[];
}





const targetStore = useTargetStore();
const menuItems = [
  {
    label: "edit",
    icon: "pi pi-pencil",
    command() {
      emits("edit-target");
    },
  },
  {
    label: "history",
    icon: "pi pi-chart-line",
    command() {
      router.push(`/targets/${props.target.id}`);
    },
  },
  {
    label: "share",
    icon: "pi pi-share-alt",
    command() {
      emits("share-target");
    },
  },
  {
    label: "delete",
    icon: "pi pi-trash",
    command() {
      targetStore.remove(props.target.id);
    },
  },
];
const menu = ref<InstanceType<typeof Menu>>();

function toggleMenu(event: Event) {
  menu.value?.toggle(event);
}

const targetDod = computed<string>(() => {
  const yesterday = props.targetDods?.find(
    (x) => x.targetId === props.target.id
  );
  if (
    yesterday &&
    props.target.value &&
    yesterday.value !== props.target.value
  ) {
    const diff = props.target.value - yesterday.value;
    const ratio = (Math.abs(diff) / props.target.value) * 100;
    return `${diff > 0 ? "+" : ""}${diff.toFixed(2)} (${parseFloat(
      ratio.toFixed(2)
    )}%) today`;
  }
  return "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "shadow-2 m-3 w-3" }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: __props.target.favicon,
              height: "17",
              class: "pi pi-globe mr-1"
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, _toDisplayString(props.target.title), 1)
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(calculateTimeAgo)(props.target.valueUpdateAt)), 1),
          (typeof props.target.value === 'number')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", null, _toDisplayString(props.target.value), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["text-2xl", 
                _unref(targetDod).startsWith('+') ? 'text-pink-500' : 'text-green-500'
              ])
                }, _toDisplayString(_unref(targetDod)), 3)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, "Value Not Found 😭"))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "pi pi-cog cursor-pointer",
            onClick: toggleMenu
          }),
          (props.target.enableGoalTrigger)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([
              props.target.isGoalTriggered ? 'text-green-500' : 'text-500'
            , "flex align-items-center mt-3"])
              }, [
                _hoisted_10,
                _createElementVNode("div", {
                  textContent: _toDisplayString(
                props.target.goalTriggerDirection === _unref(TriggerDirection).greater
                  ? '>'
                  : '<'
              ),
                  class: "mx-1"
                }, null, 8, _hoisted_11),
                _createTextVNode(" " + _toDisplayString(props.target.goalTriggerValue), 1)
              ], 2))
            : _createCommentVNode("", true),
          (props.target.enableAlertTrigger)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass([
              props.target.isAlertTriggered ? 'text-pink-600' : 'text-500'
            , "flex align-items-center mt-2"])
              }, [
                _hoisted_12,
                _createElementVNode("div", {
                  textContent: _toDisplayString(
                props.target.alertTriggerDirection === _unref(TriggerDirection).greater
                  ? '>'
                  : '<'
              ),
                  class: "mx-1"
                }, null, 8, _hoisted_13),
                _createTextVNode(" " + _toDisplayString(props.target.alertTriggerValue), 1)
              ], 2))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_unref(Menu), {
        ref: (_value, _refs) => {
          _refs['menu'] = _value
          menu.value = _value
        },
        popup: "",
        model: menuItems
      }, null, 512)
    ]),
    _: 1
  }))
}
}

})